import { MrCarousel } from '@mrhenry/wp--mr-interactive';

class MrNthCarousel extends MrCarousel {
	override async goToSlide( newIndex: number, newSlide: HTMLElement ): Promise<void> {
		this.setAttribute( 'data-was-interacted-with', '' );

		await super.goToSlide( newIndex, newSlide );

		let list = Array.from( this.children );
		list = [
			...list.slice( list.indexOf( newSlide ) ),
			...list.slice( 0, list.indexOf( newSlide ) ),
		];

		list.forEach( ( child, index ) => {
			child.setAttribute( 'data-nth-slide', index.toString() );
		} );
	}
}

customElements.define( 'mr-nth-carousel', MrNthCarousel );
